(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grid"] && !Shopify.designMode) return;
  try {
    
  const touchLikeInput = window.matchMedia('(hover: none), (pointer: coarse)').matches

  const applyHover = (el) => {
    const defaultScheme = el.dataset.defaultScheme
    const hoverScheme = el.dataset.hoverScheme
    if (defaultScheme) el.classList.remove('color-' + defaultScheme)
    if (hoverScheme) el.classList.add('color-' + hoverScheme)
  }

  const removeHover = (el) => {
    const defaultScheme = el.dataset.defaultScheme
    const hoverScheme = el.dataset.hoverScheme
    if (defaultScheme) el.classList.add('color-' + defaultScheme)
    if (hoverScheme) el.classList.remove('color-' + hoverScheme)
  }

  if (!touchLikeInput) {
    document.querySelectorAll('[data-grid-group]').forEach((el) => {
      if (el.dataset.gridHoverBound == 'true') return
      el.dataset.gridHoverBound = 'true'

      el.addEventListener('pointerenter', () => applyHover(el))
      el.addEventListener('pointerleave', () => {
        if (!el.matches(':focus-within')) removeHover(el)
      })

      el.addEventListener('focusin', () => applyHover(el))
      el.addEventListener('focusout', () => {
        if (!el.matches(':hover')) removeHover(el)
      })
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    function updateInGridMinHeight() {
      const grid = document.querySelector('results-list .product-grid');
      if (!grid) return;

      const inGridItems = grid.querySelectorAll('.in-grid-content__item');
      if (inGridItems.length === 0) return;

      const productItems = grid.querySelectorAll('.product-grid__item:not(.in-grid-content__item)');
      if (productItems.length === 0) return;

      const limit = 16;
      let minHeight = Infinity;
      for (let i = 0; i < Math.min(productItems.length, limit); i++) {
        const item = productItems[i];
        const height = item.getBoundingClientRect().height;
        if (height < minHeight) minHeight = height;
      }
      if (minHeight !== Infinity) {
        grid.style.setProperty('--in-grid-content-min-height', `${minHeight}px`);
      }
    }

    function init() {
      let rafId = null;
      const scheduleUpdate = () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          updateInGridMinHeight();
          rafId = null;
        });
      };

      updateInGridMinHeight();

      const grid = document.querySelector('results-list .product-grid');
      if (!grid) return;

      const resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(grid);

      const mutationObserver = new MutationObserver(scheduleUpdate);
      mutationObserver.observe(grid, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['product-grid-view']
      });

      window.addEventListener('resize', scheduleUpdate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
